import React from "react";

import { type FormatterUnit, toFormatter } from "~/tools/formatter-unit";
import { useScope } from "~/tools/impulse";

import { UnitPicker } from "../../_unit-picker";

import type { WidgetUnit } from "./form-state";

export interface WidgetUnitFieldProps {
	className?: string;
	disabled?: boolean;
	unit: WidgetUnit;
	default: undefined | FormatterUnit;
}

export const WidgetUnitField: React.FC<WidgetUnitFieldProps> = ({ className, unit, disabled, default: defaults }) => {
	const scope = useScope();

	return (
		<UnitPicker
			className={className}
			disabled={disabled}
			onChange={(input) => unit.setInput(input)}
			placeholder={toFormatter(defaults).name}
			unit={unit.getInput(scope)}
		/>
	);
};
